var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('RRHHSlider'),_c('div',{staticClass:"rn-section-gap parallax bg_image",style:({ backgroundImage: 'url(' + _vm.serviceImg + ')' })},[_c('RRHH')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }